var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMissionImpossible(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 160,
    viewBox: "0 0 152 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.9807 158.779L82.1749 143.067L37.347 127.918L24.5708 143.63L67.9807 158.779Z",
    fill: "#D5E6FB",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6265 154.603L76.1575 144.322L42.0559 132.282L32.5249 143.318L66.6265 154.603Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6209 84.7085C61.6209 84.7085 54.5852 86.572 51.6218 89.3717C48.6584 92.1715 47.2949 97.3438 47.2949 97.3438C47.2949 97.3438 43.3089 100.734 41.4408 101.752C39.9203 102.52 38.5678 103.582 37.462 104.877C36.3563 106.173 35.5195 107.675 35.0005 109.297C33.4733 113.879 31.6099 124.223 31.6099 124.223L36.3549 126.432C36.3549 126.432 36.4413 123.705 40.6818 119.565C44.9223 115.424 47.5449 108.37 47.8857 108.202C48.2266 108.034 55.6851 103.116 55.6851 103.116C55.6851 103.116 61.4527 107.097 67.9795 108.202C74.5062 109.306 81.7146 108.116 81.7146 108.116L79.6784 114.392C79.6784 114.392 75.0152 116.424 73.8289 118.883C72.6427 121.342 67.0477 130.668 67.0477 130.668L71.0337 133.891C74.1843 131.546 77.5295 129.475 81.0329 127.7C86.8824 124.732 88.305 122.614 90.0185 119.137C91.5735 115.675 92.8768 112.106 93.9181 108.456C94.0045 107.861 95.6998 106.338 95.9543 102.689L96.2088 99.0527L105.108 91.0852C109.993 88.9217 114.38 85.7765 117.998 81.8451C123.847 75.4002 124.779 72.2641 125.374 66.4964C125.97 60.7287 128.342 37.9262 128.424 37.5853C128.506 37.2444 129.274 35.5536 130.292 35.3809C131.31 35.2082 136.905 40.1305 137.669 40.6396C138.432 41.1486 139.941 41.4031 140.123 39.7896C140.305 38.1761 138.937 34.1947 134.615 29.8723C130.292 25.55 127.152 24.8727 126.138 25.9726C125.125 27.0725 125.797 29.4451 125.12 32.922C124.443 36.399 120.202 48.9479 118.08 54.8838C115.957 60.8196 116.639 68.8735 116.639 68.8735C114.897 69.5049 113.244 70.3589 111.721 71.4142C109.689 72.9413 106.553 75.0502 106.553 75.0502L105.708 74.6184C105.708 74.6184 110.458 69.8689 111.898 67.1554C113.339 64.442 113.762 64.2739 112.998 62.6649C112.235 61.056 106.049 53.2566 103.335 49.7751C100.622 46.2936 97.3133 40.4487 96.6179 38.7534C95.9979 37.2964 95.9669 35.6558 96.5315 34.1765C97.0406 32.9902 101.79 30.6177 101.877 26.9726C101.963 23.3274 99.604 24.341 97.3815 25.1045C95.1589 25.8681 89.2413 31.6358 87.8868 35.2809C86.5324 38.9261 87.7141 40.1123 90.0912 42.3167C92.4683 44.521 95.3635 49.0161 96.8906 53.2566C98.4177 57.4972 100.368 61.565 103.504 62.6695C103.504 62.6695 98.5041 65.042 95.1953 67.4145C91.8865 69.787 90.2775 70.8915 90.2775 70.8915C90.2775 70.8915 85.7825 72.1641 84.0871 74.3685C83.1801 75.5006 82.3855 76.7183 81.7146 78.0045C81.7146 78.0045 66.3705 80.6361 61.6209 84.7085Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M102.183 92.749L94.9423 96.1078C94.9423 96.1078 95.2923 101.585 93.3515 104.412C91.4108 107.239 90.7017 108.12 90.7017 108.12C90.7017 108.12 90.5245 112.361 89.2882 115.011C88.052 117.66 86.1067 118.542 86.1067 118.542C86.1093 119.536 85.9068 120.52 85.5118 121.431C85.1169 122.343 84.538 123.164 83.8114 123.842C81.3389 126.142 75.1758 129.85 71.2671 132.323C70.8625 132.582 70.4762 132.855 70.1035 133.136L71.0125 133.882C74.1631 131.537 77.5084 129.466 81.0117 127.691C86.8612 124.724 88.2838 122.606 89.9973 119.129C91.5523 115.667 92.8556 112.097 93.8969 108.448C93.9833 107.852 95.6786 106.33 95.9331 102.68L96.1876 99.0439L102.696 93.2172L102.183 92.749Z",
    fill: "#093269"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M67.982 108.193C73.8906 109.193 80.3718 108.311 81.5354 108.138C81.9081 107.161 82.1444 106.066 81.5354 105.648C80.4764 104.939 80.8309 102.998 80.8309 102.998C80.8309 102.998 79.9491 104.939 72.8816 104.939C65.814 104.939 56.2739 98.9346 56.2739 98.9346C56.2739 98.9346 55.5694 101.053 53.6241 101.762C51.6788 102.471 46.3793 105.47 46.3793 105.47C46.3793 105.47 46.202 110.415 42.6705 113.42C39.139 116.424 35.0666 123.419 35.0666 123.419L34.4258 125.523L36.3529 126.432C36.3529 126.432 36.4392 123.705 40.6798 119.565C44.9203 115.424 47.5428 108.37 47.8837 108.202C48.2246 108.034 55.683 103.116 55.683 103.116C55.683 103.116 61.4507 107.088 67.982 108.193Z",
    fill: "#093269"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6209 84.7085C61.6209 84.7085 54.5852 86.572 51.6218 89.3717C48.6584 92.1715 47.2949 97.3438 47.2949 97.3438C47.2949 97.3438 43.3089 100.734 41.4408 101.752C39.9203 102.52 38.5678 103.582 37.462 104.877C36.3563 106.173 35.5195 107.675 35.0005 109.297C33.4733 113.879 31.6099 124.223 31.6099 124.223L36.3549 126.432C36.3549 126.432 36.4413 123.705 40.6818 119.565C44.9223 115.424 47.5449 108.37 47.8857 108.202C48.2266 108.034 55.6851 103.116 55.6851 103.116C55.6851 103.116 61.4527 107.097 67.9795 108.202C74.5062 109.306 81.7146 108.116 81.7146 108.116L79.6784 114.392C79.6784 114.392 75.0152 116.424 73.8289 118.883C72.6427 121.342 67.0477 130.668 67.0477 130.668L71.0337 133.891C74.1843 131.546 77.5295 129.475 81.0329 127.7C86.8824 124.732 88.305 122.614 90.0185 119.137C91.5735 115.675 92.8768 112.106 93.9181 108.456C94.0045 107.861 95.6998 106.338 95.9543 102.689L96.2088 99.0527L105.108 91.0852C109.993 88.9217 114.38 85.7765 117.998 81.8451C123.847 75.4002 124.779 72.2641 125.374 66.4964C125.97 60.7287 128.342 37.9262 128.424 37.5853C128.506 37.2444 129.274 35.5536 130.292 35.3809C131.31 35.2082 136.905 40.1305 137.669 40.6396C138.432 41.1486 139.941 41.4031 140.123 39.7896C140.305 38.1761 138.937 34.1947 134.615 29.8723C130.292 25.55 127.152 24.8727 126.138 25.9726C125.125 27.0725 125.797 29.4451 125.12 32.922C124.443 36.399 120.202 48.9479 118.08 54.8838C115.957 60.8196 116.639 68.8735 116.639 68.8735C114.897 69.5049 113.244 70.3589 111.721 71.4142C109.689 72.9413 106.553 75.0502 106.553 75.0502L105.708 74.6184C105.708 74.6184 110.458 69.8689 111.898 67.1555C113.339 64.442 113.762 64.2739 112.998 62.6649C112.235 61.056 106.049 53.2566 103.335 49.7751C100.622 46.2936 97.3133 40.4487 96.6179 38.7534C95.9979 37.2964 95.9669 35.6558 96.5315 34.1765C97.0406 32.9902 101.79 30.6177 101.877 26.9726C101.963 23.3274 99.604 24.341 97.3815 25.1045C95.1589 25.8681 89.2413 31.6358 87.8868 35.2809C86.5324 38.9261 87.7141 40.1123 90.0912 42.3167C92.4683 44.521 95.3635 49.0161 96.8906 53.2566C98.4177 57.4972 100.368 61.565 103.504 62.6695C103.504 62.6695 98.5041 65.042 95.1953 67.4145C91.8865 69.787 90.2775 70.8915 90.2775 70.8915C90.2775 70.8915 85.7825 72.1641 84.0871 74.3685C83.1801 75.5006 82.3855 76.7183 81.7146 78.0045C81.7146 78.0045 66.3705 80.6361 61.6209 84.7085Z",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0753 75.041C86.0072 75.041 84.6846 75.141 83.4392 75.2683C82.7984 76.1298 82.2284 77.0418 81.7348 77.9953C81.7348 77.9953 66.3725 80.636 61.6229 84.7084C61.6229 84.7084 54.5872 86.5718 51.6238 89.3716C48.6604 92.1714 47.2969 97.3436 47.2969 97.3436C47.2969 97.3436 45.1835 99.1389 43.3154 100.525C44.7835 100.421 47.2515 100.48 48.565 101.852C49.8785 103.225 49.8058 105.688 49.6149 107.106C51.9147 105.611 55.6871 103.125 55.6871 103.125C55.6871 103.125 61.4548 107.106 67.9815 108.211C74.5082 109.315 81.7167 108.125 81.7167 108.125L81.3894 109.134C82.612 108.225 85.2527 106.861 89.0933 108.379C89.96 108.687 90.7429 109.193 91.3796 109.856C92.0164 110.52 92.4895 111.323 92.7612 112.201C93.4157 110.279 93.8883 108.738 93.9247 108.465C94.0111 107.87 95.7064 106.347 95.9609 102.698L96.2154 99.0617L103.715 92.3441C103.874 90.7124 103.669 88.2035 102.151 84.7311C99.1833 77.9226 89.6842 75.041 87.0753 75.041Z",
    fill: "#F26531"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M67.982 108.193C73.8906 109.193 80.3718 108.311 81.5354 108.138C81.9081 107.161 82.1444 106.066 81.5354 105.648C80.4764 104.939 80.8309 102.998 80.8309 102.998C80.8309 102.998 79.9491 104.939 72.8816 104.939C65.814 104.939 56.2739 98.9346 56.2739 98.9346C56.2739 98.9346 55.5694 101.053 53.6241 101.762C51.6788 102.471 46.3793 105.47 46.3793 105.47C46.3793 105.47 46.202 110.415 42.6705 113.42C39.139 116.424 35.0666 123.419 35.0666 123.419L34.4258 125.523L36.3529 126.432C36.3529 126.432 36.4392 123.705 40.6798 119.565C44.9203 115.424 47.5428 108.37 47.8837 108.202C48.2246 108.034 55.683 103.116 55.683 103.116C55.683 103.116 61.4507 107.088 67.982 108.193Z",
    fill: "#093269"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M102.183 92.749L94.9423 96.1078C94.9423 96.1078 95.2923 101.585 93.3515 104.412C91.4108 107.239 90.7017 108.12 90.7017 108.12C90.7017 108.12 90.5245 112.361 89.2882 115.011C88.052 117.66 86.1067 118.542 86.1067 118.542C86.1093 119.536 85.9068 120.52 85.5118 121.431C85.1169 122.343 84.538 123.164 83.8114 123.842C81.3389 126.142 75.1758 129.85 71.2671 132.323C70.8625 132.582 70.4762 132.855 70.1035 133.136L71.0125 133.882C74.1631 131.537 77.5084 129.466 81.0117 127.691C86.8612 124.724 88.2838 122.606 89.9973 119.129C91.5523 115.667 92.8556 112.097 93.8969 108.448C93.9833 107.852 95.6786 106.33 95.9331 102.68L96.1876 99.0439L102.696 93.2172L102.183 92.749Z",
    fill: "#093269"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0753 75.041C86.0072 75.041 84.6846 75.141 83.4392 75.2683C82.7984 76.1298 82.2284 77.0418 81.7348 77.9953C81.7348 77.9953 66.3725 80.636 61.6229 84.7084C61.6229 84.7084 54.5872 86.5718 51.6238 89.3716C48.6604 92.1714 47.2969 97.3436 47.2969 97.3436C47.2969 97.3436 45.1835 99.1389 43.3154 100.525C44.7835 100.421 47.2515 100.48 48.565 101.852C49.8785 103.225 49.8058 105.688 49.6149 107.106C51.9147 105.611 55.6871 103.125 55.6871 103.125C55.6871 103.125 61.4548 107.106 67.9815 108.211C74.5082 109.315 81.7167 108.125 81.7167 108.125L81.3894 109.134C82.612 108.225 85.2527 106.861 89.0933 108.379C89.96 108.687 90.7429 109.193 91.3796 109.856C92.0164 110.52 92.4895 111.323 92.7612 112.201C93.4157 110.279 93.8883 108.738 93.9247 108.465C94.0111 107.87 95.7064 106.347 95.9609 102.698L96.2154 99.0617L103.715 92.3441C103.874 90.7124 103.669 88.2035 102.151 84.7311C99.1833 77.9226 89.6842 75.041 87.0753 75.041Z",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5963 97.085C82.9167 98.2321 81.7116 99.9509 81.2056 101.921C80.3603 105.225 81.292 107.175 81.292 107.175",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3111 83.4171C58.3111 83.4171 54.5069 85.126 53.1752 84.367C51.8435 83.608 52.0344 80.3719 53.6297 78.5629C55.225 76.754 58.3884 76.5631 57.343 76.2904C56.2977 76.0177 54.2978 75.4314 56.484 73.7224C58.6702 72.0135 65.0469 70.4864 70.2828 72.009C75.5187 73.5315 77.4186 76.3859 77.7958 77.7176C77.9936 78.3066 78.1217 78.9168 78.1776 79.5356C78.1776 79.5356 80.4501 78.5857 80.841 79.3492C80.9537 79.5465 80.9962 79.7762 80.9615 80.0007C80.9268 80.2252 80.817 80.4314 80.6501 80.5855C80.6501 80.5855 81.5091 81.44 81.6955 83.4398C81.8818 85.4396 80.5547 87.244 79.7956 87.9848C79.0366 88.7257 77.8913 88.9393 76.5595 87.7985C75.2278 86.6577 74.4688 82.7535 73.6098 82.7535C72.7508 82.7535 69.1375 82.9444 69.0647 82.299L68.9738 81.6354L59.2656 84.1079L58.3111 83.4171Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1578 91.7438C78.1578 91.7438 78.835 99.884 76.5443 103.952C74.2536 108.02 70.0994 105.138 69.1676 104.206C68.2359 103.275 73.4945 99.3749 74.6808 96.3206C75.8671 93.2664 77.7305 90.0712 78.1578 91.7438Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M78.1612 91.7438C78.1612 91.7438 78.8384 99.884 76.5477 103.952C74.257 108.02 70.1028 105.138 69.1711 104.206C68.2393 103.275 73.498 99.3749 74.6842 96.3206C75.8705 93.2664 77.734 90.0712 78.1612 91.7438Z",
    fill: "#093269"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1578 91.7438C78.1578 91.7438 78.835 99.884 76.5443 103.952C74.2536 108.02 70.0994 105.138 69.1676 104.206C68.2359 103.275 73.4945 99.3749 74.6808 96.3206C75.8671 93.2664 77.7305 90.0712 78.1578 91.7438Z",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3115 83.4172C58.562 87.9291 59.4589 92.3818 60.9749 96.6388C63.4474 103.393 67.6334 105.679 69.4424 105.774C71.2513 105.87 74.6737 102.443 76.1963 99.2067C77.2173 96.9556 78.0769 94.6348 78.7688 92.2619C78.7688 92.2619 80.955 91.5029 81.5277 89.503C82.1004 87.5032 81.9822 85.6988 80.4778 85.5079C78.9734 85.317 78.2916 87.5077 78.2916 87.5077C77.0279 86.5883 76.0939 85.2862 75.6282 83.7944C74.8646 81.3219 76.3872 79.4175 75.6282 79.8948C74.8692 80.372 73.3557 81.8946 72.583 81.6083C71.8104 81.3219 73.0375 79.1357 73.0375 79.1357C73.0375 79.1357 60.7113 82.3673 58.3115 83.4172Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4873 88.4579L78.6733 86.8398",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5947 88.9357L56.2227 87.4131C56.2227 87.4131 56.3181 90.0765 57.6498 91.5991C58.9815 93.1217 61.7404 93.3126 62.7857 92.9308C63.8311 92.549 63.6402 89.5993 64.7856 89.8856C65.9309 90.1719 65.7355 91.4082 66.2127 92.549C66.6899 93.6898 67.1626 93.5944 69.2533 93.8807C71.3441 94.1671 73.3439 93.9762 74.1075 92.9308C74.871 91.8854 75.2483 88.6494 74.4893 88.4585C73.7302 88.2676 71.1577 88.6493 68.3989 88.7448C65.64 88.8402 64.5947 88.9357 64.5947 88.9357Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2538 93.881C71.3491 94.1673 73.3444 93.9764 74.108 92.9311C74.6579 92.172 75.017 90.2722 74.8715 89.2041L66.6904 93.2947C67.104 93.6674 67.7767 93.681 69.2538 93.881Z",
    fill: "#D5E6FB"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7851 92.9311C63.8304 92.5493 63.6396 89.5996 64.7849 89.8859C65.4621 90.0586 65.6712 90.5677 65.8303 91.1949L68.7118 88.7314H68.3982C67.5801 88.7587 66.912 88.786 66.3802 88.8133L58.0991 91.9948C58.7689 92.4748 59.5332 92.8066 60.3412 92.968C61.1492 93.1294 61.9823 93.1169 62.7851 92.9311Z",
    fill: "#D5E6FB"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5947 88.9357L56.2227 87.4131C56.2227 87.4131 56.3181 90.0765 57.6498 91.5991C58.9815 93.1217 61.7404 93.3126 62.7857 92.9308C63.8311 92.549 63.6402 89.5993 64.7856 89.8856C65.9309 90.1719 65.7355 91.4082 66.2127 92.549C66.6899 93.6898 67.1626 93.5944 69.2533 93.8807C71.3441 94.1671 73.3439 93.9762 74.1075 92.9308C74.8711 91.8854 75.2483 88.6494 74.4893 88.4585C73.7302 88.2676 71.1577 88.6493 68.3989 88.7448C65.64 88.8402 64.5947 88.9357 64.5947 88.9357Z",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0198 91.9805C64.0198 91.9805 63.9243 94.453 63.9243 95.9756C63.9243 97.4982 64.497 97.4982 65.5424 97.4027C66.1247 97.367 66.6853 97.1686 67.1604 96.83",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3522 100.07C67.3522 100.07 69.3475 97.4071 71.3473 97.6889C73.3471 97.9706 73.3426 99.7841 72.2972 100.452C71.2519 101.12 68.5885 101.498 67.9203 101.307C67.2522 101.116 66.9704 100.448 67.3522 100.07Z",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3933 98.3525C72.3933 98.3525 69.9208 100.448 67.4482 100.539",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0664 86.7449C65.0664 86.7449 66.3027 88.0766 66.7799 87.6993C67.2571 87.3221 68.9706 85.604 70.9659 85.4268C72.9612 85.2495 73.2384 85.6177 72.9657 85.2359C72.693 84.8541 71.3477 84.1905 69.7296 84.3814C68.1116 84.5723 66.9708 86.1994 66.3981 86.4722C65.9767 86.6505 65.524 86.7432 65.0664 86.7449Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8813 86.3671C62.8813 86.3671 62.6904 87.1262 62.404 87.2216C62.1177 87.3171 62.0223 87.3171 60.4088 86.8398C58.7953 86.3626 58.3135 86.2717 58.3135 86.2717C58.3135 86.2717 58.218 85.5081 59.3589 85.4127C60.4997 85.3172 61.9314 86.1762 61.9314 86.1762C61.9314 86.1762 62.5949 86.6489 62.8813 86.3671Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0107 73.5231C74.0107 73.5231 78.2922 75.3411 78.674 82.4632L79.5284 82.3678C79.529 80.1775 79.0756 78.0109 78.1967 76.0047C76.7696 72.9504 74.0107 73.5231 74.0107 73.5231Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7481 85.4537C77.4325 85.4459 77.1295 85.3288 76.8906 85.1224C76.6518 84.9161 76.4919 84.6333 76.4383 84.3223C76.3847 84.0112 76.4406 83.6912 76.5966 83.4168C76.7525 83.1424 76.9989 82.9306 77.2936 82.8176L81.2978 81.3859C81.6248 81.3078 81.9692 81.3534 82.2648 81.5138C82.5603 81.6742 82.7861 81.9382 82.8988 82.255C83.0116 82.5718 83.0033 82.9191 82.8755 83.2301C82.7478 83.5412 82.5096 83.7941 82.2068 83.9402L78.2026 85.3719C78.057 85.4253 77.9032 85.453 77.7481 85.4537Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M78.156 83.9266C78.3742 84.5129 78.2015 85.1219 77.7651 85.2901C77.3288 85.4582 76.797 85.1128 76.5743 84.522C76.3516 83.9311 76.5289 83.3266 76.9652 83.1584C77.4015 82.9903 77.9333 83.3402 78.156 83.9266Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6779 91.4988C77.6779 91.7399 77.5821 91.9711 77.4116 92.1415C77.2412 92.312 77.01 92.4078 76.7689 92.4078C76.5278 92.4078 76.2966 92.312 76.1261 92.1415C75.9556 91.9711 75.8599 91.7399 75.8599 91.4988C75.8599 90.9943 76.7689 88.9854 76.7689 88.9854C76.7689 88.9854 77.6779 90.9806 77.6779 91.4988Z",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M126.162 25.9545C125.144 27.0544 125.821 29.4269 125.144 32.9039C124.467 36.3808 120.226 48.9297 118.104 54.8656C115.981 60.8014 116.663 68.8553 116.663 68.8553C114.921 69.4867 113.268 70.3407 111.745 71.396C109.714 72.9231 106.578 75.032 106.578 75.032L105.71 74.6184C105.71 74.6184 110.459 69.8688 111.9 67.1554C113.341 64.442 113.763 64.2739 113 62.6649C112.236 61.056 106.05 53.2566 103.337 49.7751C100.624 46.2936 97.3148 40.4487 96.6194 38.7534C95.9994 37.2964 95.9684 35.6558 96.533 34.1765C97.0421 32.9902 101.792 30.6177 101.878 26.9726C101.964 23.3274 99.6055 24.341 97.383 25.1045C95.1604 25.8681 89.2428 31.6358 87.8883 35.2809C86.5339 38.9261 87.7156 40.1123 90.0927 42.3167C92.4698 44.521 95.365 49.0161 96.8921 53.2566C98.4192 57.4972 100.369 61.565 103.505 62.6695C103.505 62.6695 98.5056 65.042 95.1968 67.4145C91.888 69.787 90.279 70.8915 90.279 70.8915C90.279 70.8915 85.784 72.1641 84.0887 74.3685C83.3497 75.3132 82.677 76.3079 82.0752 77.3455C84.0114 76.6364 88.7019 75.5502 94.1787 78.7726C100.974 82.7677 102.414 89.399 102.414 93.485L105.114 91.067C109.999 88.9035 114.386 85.7583 118.004 81.8269C123.853 75.382 124.785 72.2459 125.381 66.4782C125.976 60.7105 128.348 37.908 128.43 37.5671C128.512 37.2262 129.28 35.5355 130.298 35.3627C131.316 35.19 136.911 40.1123 137.675 40.6214C138.439 41.1304 139.947 41.3849 140.129 39.7714C140.311 38.158 138.943 34.1765 134.621 29.8541C130.298 25.5318 127.158 24.85 126.162 25.9545Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M96.8032 71.5645C96.8032 71.5645 105.793 72.7553 110.538 80.0455",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M140.13 39.7718C140.302 38.1628 138.943 34.1768 134.621 29.8544C130.299 25.5321 127.158 24.8549 126.144 25.9548C125.131 27.0547 125.804 29.4272 125.126 32.9042C125.035 33.3587 124.876 34.0041 124.672 34.7586C125.668 34.622 126.678 34.869 127.499 35.4494C128.014 35.7787 128.474 36.1866 128.862 36.6584C129.199 36.0903 129.703 35.463 130.303 35.363C131.317 35.1949 136.916 40.1126 137.68 40.6217C138.443 41.1307 139.961 41.3853 140.13 39.7718Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M90.1105 42.3167C90.6273 42.8055 91.1131 43.3262 91.5649 43.8756C92.765 43.884 93.9449 43.5668 94.979 42.9577C96.0131 42.3486 96.8626 41.4705 97.4371 40.4168C97.069 39.7124 96.7872 39.126 96.6372 38.7534C96.0172 37.2964 95.9863 35.6558 96.5509 34.1765C97.0599 32.9902 101.809 30.6177 101.896 26.9726C101.982 23.3274 99.6233 24.341 97.4008 25.1045C95.1783 25.8681 89.2606 31.6358 87.9061 35.2809C86.5517 38.9261 87.7334 40.1123 90.1105 42.3167Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M97.4016 25.1041C95.1972 25.8677 89.2613 31.6353 87.9069 35.2805C86.8388 38.1393 87.3479 39.4892 88.7614 40.9982C89.406 40.8255 90.009 40.524 90.534 40.1119C92.5701 38.5847 93.4155 35.8713 94.6881 34.9396C95.4108 34.4078 96.7107 33.5761 98.0288 32.6898C99.6014 31.3581 101.838 29.4628 101.897 26.9721C101.978 23.3224 99.6059 24.3405 97.4016 25.1041Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M97.3989 25.1044C95.1946 25.8679 89.2587 31.6356 87.9043 35.2807C87.1453 37.3124 87.1816 38.5805 87.7725 39.6895C88.2279 39.771 88.6956 39.7523 89.1431 39.6345C89.5905 39.5168 90.0069 39.3029 90.3632 39.0077C93.1584 36.9761 92.1403 34.8535 94.5992 33.6672C97.1372 32.4228 99.4541 30.7707 101.458 28.7768C101.73 28.2076 101.885 27.5892 101.912 26.9587C101.976 23.3227 99.6033 24.3408 97.3989 25.1044Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M140.129 39.7718C140.302 38.1628 138.943 34.1768 134.621 29.8544C130.298 25.5321 127.158 24.8549 126.144 25.9548C125.844 26.3167 125.659 26.7597 125.612 27.2274C126.412 26.941 127.758 26.7729 129.535 27.5637C132.503 28.9272 137.925 35.7039 138.775 37.5629C139.27 38.6537 139.129 39.9945 139.011 40.9944C139.557 40.9853 140.038 40.6399 140.129 39.7718Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M106.241 87.3082L102.273 90.5261C102.234 90.5587 102.203 90.5999 102.182 90.6464C102.162 90.6929 102.152 90.7435 102.155 90.7942L102.291 94.303C102.295 94.3635 102.315 94.4218 102.349 94.4717C102.384 94.5215 102.431 94.561 102.486 94.5858C102.541 94.6106 102.602 94.6198 102.663 94.6124C102.723 94.6051 102.78 94.5814 102.827 94.5439L106.918 91.2442C106.963 91.2158 107 91.1771 107.027 91.1312C107.054 91.0854 107.07 91.0337 107.072 90.9806L106.8 87.54C106.8 87.4751 106.781 87.4117 106.745 87.3577C106.709 87.3038 106.658 87.2617 106.598 87.2369C106.538 87.212 106.472 87.2056 106.408 87.2182C106.345 87.2309 106.286 87.2622 106.241 87.3082Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M104.435 51.284C104.313 34.2431 104.313 17.4082 104.435 0.779297",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M104.435 88.6946V51.2842",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6772 78.3499C79.7681 52.4431 79.7681 26.5362 79.6772 0.792969",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6113 123.518C73.6433 122.468 72.5571 122.25 71.9753 122.241C71.239 123.532 70.4027 124.968 69.6255 126.286C71.0254 126.514 73.1161 127.036 74.4069 128.191C75.1212 128.823 75.752 129.544 76.284 130.336C77.3657 129.677 78.5565 128.972 79.8837 128.282C79.1747 126.886 77.7657 124.668 75.6113 123.518Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0837 120.778L69.4297 128.787L73.4975 131.377L81.3832 123.487L76.0837 120.778Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4515 122.174L71.4429 128.091L73.4109 129.241L79.1649 123.406L76.4515 122.174Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2919 130.522C32.3373 128.431 31.3829 125.373 31.1511 124.709C30.6193 123.068 29.4376 122.391 28.5013 123.241C27.7559 123.927 28.2059 125.468 28.3831 126.295C28.6313 127.779 28.9837 129.243 29.4376 130.677C29.6421 131.249 29.8921 132.336 30.5966 132.495C31.8374 132.758 32.2601 131.831 32.2919 130.522Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6865 132.277C29.7229 130.704 28.9911 128.409 28.8321 127.909C28.4275 126.677 27.5413 126.168 26.8413 126.809C26.2777 127.323 26.6186 128.482 26.7504 129.104C26.9366 130.218 27.2008 131.318 27.5413 132.395C27.6958 132.822 27.8821 133.636 28.4139 133.759C29.3502 133.949 29.6638 133.25 29.6865 132.277Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4425 125.373C37.4425 125.373 39.3696 127.746 40.9967 127.968C41.6017 128.023 42.1854 128.219 42.7008 128.54C43.2163 128.861 43.6492 129.299 43.9647 129.818C44.4828 130.636 42.7784 133.377 42.7011 134.34C42.6239 135.304 41.9603 135.454 41.074 134.936C40.1877 134.418 39.8877 133.009 40.165 131.968C40.4422 130.927 40.6195 130.636 40.3877 130.559C39.4805 130.32 38.5894 130.024 37.7198 129.673C37.2198 129.377 37.4425 125.373 37.4425 125.373Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2826 129.878C35.3281 127.787 34.3736 124.728 34.1418 124.065C33.61 122.424 32.4238 121.747 31.492 122.596C30.7466 123.283 31.1966 124.824 31.3739 125.651C31.622 127.134 31.9744 128.598 32.4283 130.032C32.6328 130.605 32.8828 131.691 33.5873 131.85C34.8281 132.105 35.2599 131.178 35.2826 129.878Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8357 130.714C38.8811 128.623 37.9267 125.56 37.6949 124.9C37.1631 123.26 35.9768 122.582 35.0451 123.432C34.2997 124.114 34.7497 125.659 34.9224 126.487C35.1721 127.97 35.526 129.434 35.9814 130.868C36.1859 131.436 36.4359 132.527 37.1404 132.686C38.3812 132.941 38.8039 132.013 38.8357 130.714Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8407 140.254C67.4815 137.941 69.5041 135.077 69.9495 134.459C71.0449 132.937 72.5038 132.791 73.1947 134.191C73.7492 135.318 72.7674 136.782 72.3129 137.6C71.5695 139.082 70.7173 140.507 69.7632 141.863C69.3632 142.381 68.7451 143.454 67.9451 143.258C66.5771 142.917 66.4407 141.69 66.8407 140.254Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2875 141.703C70.7693 139.967 72.2873 137.817 72.6191 137.354C73.4463 136.208 74.5371 136.099 75.0552 137.154C75.4734 137.999 74.7371 139.095 74.3962 139.708C73.8399 140.823 73.2003 141.894 72.4827 142.912C72.1782 143.303 71.7192 144.108 71.1192 143.958C70.0875 143.703 69.9875 142.794 70.2875 141.703Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4834 130.231C64.4834 130.231 61.6928 131.859 59.9156 131.277C58.1385 130.695 57.025 131.181 56.216 131.809C55.4069 132.436 56.275 136.304 56.0342 137.399C55.7933 138.494 56.4432 138.99 57.5386 138.867C58.6339 138.744 59.4111 137.358 59.4475 136.072C59.4839 134.786 59.4248 134.386 59.6793 134.417C59.9338 134.449 62.1155 134.872 62.7563 134.79C63.3972 134.708 64.4834 130.231 64.4834 130.231Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2562 136.254C65.897 133.941 67.9151 131.078 68.3605 130.459C69.4604 128.937 70.9148 128.791 71.6056 130.196C72.1601 131.318 71.183 132.782 70.7239 133.6C69.9838 135.083 69.1329 136.508 68.1787 137.863C67.7742 138.386 67.1606 139.454 66.3606 139.259C64.9835 138.918 64.8471 137.695 65.2562 136.254Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2655 135.377C61.9063 133.064 63.9289 130.2 64.3743 129.582C65.4697 128.06 66.9286 127.914 67.6195 129.314C68.174 130.441 67.1922 131.905 66.7377 132.723C65.9943 134.205 65.1421 135.63 64.188 136.986C63.788 137.504 63.1699 138.577 62.3699 138.381C61.0019 138.041 60.8655 136.813 61.2655 135.377Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4751 121.501L24.5699 143.631L67.9797 158.78L65.4936 137.64L16.4751 121.501Z",
    fill: "#D5E6FB",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M114.302 108.896H128.096",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M104.456 108.896H109.273",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M125.689 111.415H128.098",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M118.902 111.415H123.72",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M104.456 111.415H115.618",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M115.839 113.929H128.097",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M104.456 113.929H113.214",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M122.843 116.446H128.097",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M109.708 116.446H120.653",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M104.456 116.446H107.301",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M114.302 118.646H128.096",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M104.456 118.646H109.273",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M125.689 121.164H128.098",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M118.902 121.164H123.72",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M104.456 121.164H115.618",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M115.839 123.678H128.097",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M104.456 123.678H113.214",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M125.689 128.404H128.098",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M118.902 128.404H123.72",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M104.456 128.404H115.618",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M115.839 130.918H128.097",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M104.456 130.918H113.214",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M122.843 133.437H128.097",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M109.708 133.437H120.653",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M104.456 133.437H107.301",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M114.302 135.636H128.096",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M104.456 135.636H109.273",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M125.689 138.149H128.098",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M118.902 138.149H123.72",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M104.456 138.149H115.618",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M130.974 142.739L132.746 134.749L134.523 139.78L136.891 118.182L140.146 134.749L143.991 106.047L148.136 139.185L149.908 135.931L150.795 142.444",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M106.314 104.038L116.49 93.8665L123.976 100.584L130.312 94.8255L139.716 101.929L149.892 91.1758",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M117.83 93.8665C117.835 93.595 117.758 93.3283 117.61 93.1006C117.462 92.8729 117.249 92.6946 116.999 92.5886C116.749 92.4826 116.473 92.4537 116.207 92.5056C115.94 92.5575 115.695 92.6878 115.503 92.8798C115.311 93.0719 115.181 93.3169 115.129 93.5835C115.077 93.8501 115.106 94.1261 115.212 94.3762C115.318 94.6262 115.496 94.8389 115.724 94.987C115.951 95.1351 116.218 95.2118 116.49 95.2073C116.843 95.2015 117.181 95.0583 117.431 94.8081C117.681 94.5579 117.825 94.2203 117.83 93.8665Z",
    fill: "#D5E6FB",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M131.653 94.8252C131.653 94.5546 131.573 94.2901 131.422 94.0654C131.271 93.8407 131.057 93.666 130.806 93.5635C130.556 93.461 130.28 93.4353 130.015 93.4898C129.75 93.5443 129.507 93.6764 129.318 93.8694C129.128 94.0624 129 94.3075 128.95 94.5734C128.9 94.8394 128.93 95.1143 129.037 95.363C129.143 95.6117 129.322 95.823 129.549 95.9701C129.776 96.1172 130.042 96.1933 130.313 96.1888C130.67 96.1828 131.011 96.0365 131.262 95.7815C131.513 95.5264 131.653 95.183 131.653 94.8252Z",
    fill: "#D5E6FB",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M139.714 103.275C140.457 103.275 141.06 102.672 141.06 101.929C141.06 101.186 140.457 100.584 139.714 100.584C138.971 100.584 138.369 101.186 138.369 101.929C138.369 102.672 138.971 103.275 139.714 103.275Z",
    fill: "#D5E6FB",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M151.047 91.176C151.047 90.9063 150.967 90.6427 150.818 90.4185C150.668 90.1943 150.455 90.0195 150.206 89.9163C149.956 89.8131 149.682 89.7861 149.418 89.8387C149.153 89.8913 148.91 90.0212 148.72 90.2119C148.529 90.4026 148.399 90.6455 148.347 90.91C148.294 91.1745 148.321 91.4487 148.424 91.6978C148.527 91.947 148.702 92.1599 148.926 92.3097C149.151 92.4596 149.414 92.5395 149.684 92.5395C150.045 92.5395 150.392 92.3959 150.648 92.1402C150.904 91.8845 151.047 91.5376 151.047 91.176Z",
    fill: "#D5E6FB",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M106.315 105.384C107.058 105.384 107.66 104.782 107.66 104.039C107.66 103.296 107.058 102.693 106.315 102.693C105.572 102.693 104.97 103.296 104.97 104.039C104.97 104.782 105.572 105.384 106.315 105.384Z",
    fill: "#D5E6FB",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M123.977 101.543C124.72 101.543 125.323 100.941 125.323 100.198C125.323 99.4549 124.72 98.8525 123.977 98.8525C123.234 98.8525 122.632 99.4549 122.632 100.198C122.632 100.941 123.234 101.543 123.977 101.543Z",
    fill: "#D5E6FB",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M33.416 60.1107L37.3702 57.8291",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1353 57.8286V71.2411L25.7524 77.9496L37.3696 71.2411V57.8286L25.7524 51.1201L14.1353 57.8286Z",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0854 60.1105V68.9597L25.753 73.3866L33.4159 68.9597V60.1105L25.753 55.6836L18.0854 60.1105Z",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7524 51.12V41.1572",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7519 42.621C26.8338 42.621 27.7108 41.7439 27.7108 40.662C27.7108 39.5802 26.8338 38.7031 25.7519 38.7031C24.67 38.7031 23.793 39.5802 23.793 40.662C23.793 41.7439 24.67 42.621 25.7519 42.621Z",
    fill: "#D5E6FB",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7524 77.668V87.6307",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7896 88.1259C23.7887 88.5144 23.903 88.8945 24.1182 89.218C24.3334 89.5415 24.6398 89.7939 24.9985 89.9432C25.3572 90.0925 25.7521 90.132 26.1333 90.0567C26.5145 89.9815 26.8647 89.7949 27.1398 89.5204C27.4148 89.246 27.6023 88.8962 27.6784 88.5152C27.7546 88.1342 27.7159 87.7392 27.5675 87.3801C27.419 87.0211 27.1673 86.7142 26.8443 86.4982C26.5213 86.2823 26.1415 86.167 25.753 86.167C25.2331 86.167 24.7343 86.3732 24.3662 86.7405C23.9982 87.1077 23.7908 87.606 23.7896 88.1259Z",
    fill: "#D5E6FB",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0849 60.1107L14.1353 57.8291",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4199 69.0275L26.0829 64.6006L33.4141 68.9593",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0835 64.601V55.6836",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6235 21.1592H54.8776",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4888 21.1592H47.4378",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2324 21.1592H34.0776",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0889 23.3594H54.8786",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2324 23.3594H36.0502",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4727 25.877H54.877",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6826 25.877H50.5004",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2324 25.877H42.3996",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6191 28.3906H54.8772",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2324 28.3906H39.9908",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6235 30.9082H54.8776",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4888 30.9082H47.4378",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2324 30.9082H34.0776",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0889 33.1084H54.8786",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2324 33.1084H36.0502",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4727 35.6211H54.877",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6826 35.6211H50.5004",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2324 35.6211H42.3996",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6191 38.1396H54.8772",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2324 38.1396H39.9908",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6235 40.6523H54.8776",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4888 40.6523H47.4378",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2324 40.6523H34.0776",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0889 42.8574H54.8786",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2324 42.8574H36.0502",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M54.877 45.3701H52.4727",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6826 45.3701H50.5004",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2324 45.3701H42.3996",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6191 47.8887H54.8772",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2324 47.8887H39.9908",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6235 50.4023H54.8776",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4888 50.4023H47.4378",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2324 50.4023H34.0776",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMissionImpossible);
export default __webpack_public_path__ + "static/media/MissionImpossible.aad41b5f40cefd2d497ba705695ac3be.svg";
export { ForwardRef as ReactComponent };